import React from 'react';
import PropTypes from 'prop-types';
import { isLinkWithSameOrigin } from 'site-modules/canvas/utils/is-same-origin';

export function MarkdownLink({
  href = '#',
  children = undefined,
  onClick = undefined,
  target = undefined,
  rel = undefined,
  className = 'text-decoration-underline',
  elementRef,
}) {
  const linkHref = href.replace('https://www.edmunds.com', '');
  const isSameOrigin = isLinkWithSameOrigin(href);

  return (
    <a
      ref={elementRef}
      className={className}
      onClick={onClick}
      href={linkHref}
      target={isSameOrigin ? target : '_blank'}
      rel={isSameOrigin ? rel : 'noopener noreferrer'}
    >
      {children}
    </a>
  );
}

MarkdownLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  target: PropTypes.string,
  rel: PropTypes.string,
  className: PropTypes.string,
  elementRef: PropTypes.shape({}),
};
